<template>
    <header class="header-container">
      <!-- Background Video -->
      <div class="background-video">
       <img src="../../assets/cover.png" width="100%" alt="">
       
     
      </div>
  
      <!-- Video Overlay for Better Text Readability -->
      <div class="video-overlay"></div>
  
      <!-- Header Content -->
     
    <div class="header-content">
      <div class="content-wrapper">
        <div class="cover-left">
       
          <h1 class="cover-title">
            SAS<br />
            ADMISSION<br />
          
          </h1>
 
        </div>
      </div>
    </div>
  </header>
  </template>
  
  <script>
  export default {
    name: 'Header',
    data() {
      return {
        // Data for header
      }
    }
  }
  </script>
  
  <style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  /* ==================== Header Container ==================== */
  .header-container {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* ==================== Background Video ==================== */
  .background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.background-video img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
  /* ==================== Video Overlay ==================== */
  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(192, 33, 48, 0.6) 0%, rgba(247, 240, 43, 0.3) 100%);
    z-index: 2;
  }
  
  /* ==================== Header Content ==================== */
  .header-content {
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    /* On large screens place text bottom-left */
    align-items: flex-end;    /* vertical: bottom */
    justify-content: center; /* horizontal: left */
    padding: 40px 20px;
  }
  
  .content-wrapper {
    max-width: 800px;
    animation: fadeInUp 1s ease-out;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* ==================== Header Title ==================== */
  .header-title0 {
    font-size: 44px;
    font-weight: 800;
    color: white;
    margin-bottom: 2px;
    letter-spacing: -2px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4);
    animation: slideInDown 0.8s ease-out;
  }
  .header-title {
    font-size: 80px;
    font-weight: 800;
    color: white;
    margin-bottom: 2px;
    letter-spacing: -2px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4);
    animation: slideInDown 0.8s ease-out;
  }
  
  .cover-left {
    max-width: 55%;
    color: white;
    text-shadow: 0 6px 20px rgba(0,0,0,0.6);
  }
  
  .eyebrow {
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 2px;
    color: rgba(255,255,255,0.95);
    margin-bottom: 8px;
  }
  
  .cover-title {
    font-size: 84px;
    line-height: 0.95;
    margin: 0;
    font-weight: 900;
    letter-spacing: -2px;
  }
  
  @keyframes slideInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* ==================== Header Subtitle ==================== */
  .header-subtitle {
    font-size: 24px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 10px;
    letter-spacing: 0.5px;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
    animation: fadeInUp 0.8s ease-out 0.2s backwards;
  }
  
  /* ==================== CTA Button ==================== */
  .cta-button {
    padding: 18px 50px;
    font-size: 16px;
    font-weight: 700;
    color: white;
    background: linear-gradient(135deg, #C02130 0%, #F7F02B 100%);
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 15px 40px rgba(192, 33, 48, 0.4);
    letter-spacing: 0.5px;
    animation: fadeInUp 0.8s ease-out 0.4s backwards;
  }
  
  .cta-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 20px 50px rgba(192, 33, 48, 0.6);
  }
  
  .cta-button:active {
    transform: translateY(-1px);
  }
  
  /* ==================== Bottom Left Text ==================== */
  .bottom-left-text {
    position: absolute;
    bottom: 40px;
    left: 40px;
    z-index: 3;
    animation: fadeInUp 1.2s ease-out 0.6s backwards;
  }
  
  .bottom-left-text p {
    font-size: 18px;
    font-weight: 700;
    color: white;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4);
    letter-spacing: 0.5px;
  }
  
  /* ==================== Responsive Design ==================== */
  @media (max-width: 768px) {
    .header-content {
      align-items: flex-end;
      justify-content: flex-start;
      min-height: unset;
    }
    .background-video img {
    height: 100%;
    object-fit: cover;
  }
  
    .content-wrapper {
      max-width: 100%;
    }
  
    .cover-left {
      max-width: 100%;
    }
  
    .cover-title {
      font-size: 48px;
      line-height: 1.1;
    }
  
    .cta-button {
      margin-top: 20px;
    }
  }
  
  @media (max-width: 480px) {
    .header-content {
      padding: 20px;
      min-height: unset;
    }
    .background-video img {
    height: 100%;
    object-fit: cover;
  }
  
    .eyebrow {
      font-size: 12px;
      letter-spacing: 1.5px;
    }
  
    .cover-title {
      font-size: 36px;
      line-height: 1.15;
    }
  
    .cta-button {
      width: 100%;
      padding: 14px 0;
      font-size: 14px;
    }
  }
  </style>